import './styles/main.css';
import { App } from './js/app.js';

document.addEventListener('DOMContentLoaded', () => {
  const app = new App();
  app.mount('#app');
  window.app = app;
});